/**
 * Предупреждения мастера подключения (KAN-601).
 */
import { Alert, AlertDescription } from '@/components/ui/alert';
import type { ConnectScheme } from '@/types/telegramAccount';

interface Props {
  scheme: ConnectScheme;
  relogin: boolean;
}

export function ConnectWarnings({ scheme, relogin }: Props): JSX.Element {
  return (
    <div className="space-y-2" data-testid="connect-warnings">
      <Alert>
        <AlertDescription>
          Свежий аккаунт (моложе суток) не трогайте сутки: без лишних входов и
          изменений настроек.
        </AlertDescription>
      </Alert>
      {relogin && (
        <Alert>
          <AlertDescription>
            Перед повторным входом в мёртвый аккаунт сделайте паузу 10-30 минут.
          </AlertDescription>
        </Alert>
      )}
      {(scheme === 'code' || scheme === 'code_2fa') && (
        <Alert>
          <AlertDescription>
            Купленный аккаунт входите по коду один раз, не повторяйте запрос
            кода.
          </AlertDescription>
        </Alert>
      )}
    </div>
  );
}
